import React, { useState, useMemo } from 'react';
import { Paper, TextField, InputAdornment, Box, Chip, Tooltip, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DataGrid } from '@material-ui/data-grid';
import SearchIcon from '@material-ui/icons/Search';
import GetAppIcon from '@material-ui/icons/GetApp';

const useStyles = makeStyles((theme) => ({
  dataGridContainer: {
    height: '60vh',
    width: '100%',
    maxWidth: '1000px',
    overflow: 'hidden',
    '& .MuiDataGrid-root': {
      width: '100%',
    },
    '& .MuiDataGrid-window': {
      left: 0,
      right: 0,
      bottom: 0,
      position: 'absolute',
      overflowX: 'hidden',
    },
    '& .MuiDataGrid-columnHeaders': {
      backgroundColor: '#4472c4 !important',
      color: 'white !important',
    },
    '& .MuiDataGrid-columnHeader': {
      backgroundColor: '#4472c4 !important',
      color: 'white !important',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 'bold !important',
      color: 'white !important',
    },
    '& .MuiDataGrid-iconSeparator': {
      color: 'white !important',
    },
    '& .MuiDataGrid-sortIcon': {
      color: 'white !important',
    },
    '& .MuiDataGrid-menuIcon': {
      color: 'white !important',
    },
    '& .MuiDataGrid-columnHeaderTitleContainer': {
      color: 'white !important',
    },
    '& .MuiDataGrid-row': {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#e3ecfa !important',
      },
    },
  },
  searchField: {
    marginBottom: theme.spacing(2),
  },
  statusChip: {
    backgroundColor: 'rgb(214, 214, 214)',
    color: 'rgb(61, 61, 61)',
    fontWeight: 500,
  },
}));

const RepsListTable = ({
  reps,
  onRepClick,
  isLoading,
}) => {
  const classes = useStyles();
  const [searchText, setSearchText] = useState('');
  const [pageSize, setPageSize] = useState(50);

  const columns = [
    // {
    //   field: 'UserID',
    //   headerName: 'User ID',
    //   flex: 0.8,
    //   minWidth: 100,
    //   sortable: true,
    //   disableColumnMenu: true,
    // },
    {
      field: 'Full_Name',
      headerName: 'Full Name',
      flex: 1,
      minWidth: 150,
      sortable: true,
      disableColumnMenu: true,
    },
    {
      field: 'Email',
      headerName: 'Email',
      flex: 1.5,
      minWidth: 180,
      sortable: true,
      disableColumnMenu: true,
    },
    {
      field: 'Status',
      headerName: 'CRM Status',
      flex: 1,
      minWidth: 150,
      sortable: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Chip
          label={params.value}
          className={classes.statusChip}
          size="small"
        />
      ),
    },
  ];

  const rows = useMemo(() => {
    return reps.map((rep, index) => ({
      id: `${rep.UserID}-${index}`,
      UserID: rep.UserID,
      Full_Name: rep.Full_Name,
      Email: rep.Email,
      Status: rep.Status,
    }));
  }, [reps]);

  const filteredRows = useMemo(() => {
    if (!searchText) return rows;

    const searchLower = searchText.toLowerCase();
    return rows.filter((row) => {
      return (
        row.Full_Name?.toLowerCase().includes(searchLower) ||
        row.Email?.toLowerCase().includes(searchLower) ||
        row.UserID?.toString().toLowerCase().includes(searchLower) ||
        row.Status?.toLowerCase().includes(searchLower)
      );
    });
  }, [rows, searchText]);
  console.log('rows_debug',filteredRows)
  // CSV Export Function
  const handleExportCSV = () => {
    const headers = columns.map(col => col.headerName).join(',');
    const csvRows = filteredRows.map(row => {
      return columns.map(col => {
        const field = col.field;
        let value = row[field];

        // Escape commas and quotes in CSV
        if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
          value = `"${value.replace(/"/g, '""')}"`;
        }

        return value;
      }).join(',');
    });

    const csvContent = [headers, ...csvRows].join('\n');

    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'reps_list.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Paper elevation={2} style={{ maxWidth: '1000px', padding: '1.5rem' }}>
      <Box display="flex" alignItems="center" gap={1} style={{ marginBottom: '16px' }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search by name, email, user ID, or status..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
        />
        <Tooltip title="Download as CSV" arrow>
          <IconButton
            onClick={handleExportCSV}
            style={{
              padding: '8px',
              margin: '0 8px',
            }}
          >
            <GetAppIcon />
          </IconButton>
        </Tooltip>
      </Box>
      <div className={classes.dataGridContainer}>
        <DataGrid
          rows={filteredRows}
          columns={columns}
          loading={isLoading}
          onRowClick={(params) => onRepClick(params.row.UserID, params.row.Full_Name)}
          disableSelectionOnClick
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[10, 25, 50, 100]}
          pagination
          disableColumnMenu
        />
      </div>
    </Paper>
  );
};

export default RepsListTable;
